import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from 'antd';

import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Welcome from './pages/Welcome';
import MasterData from './pages/MasterData';
import PermissionManagement from './pages/PermissionManagement';
import SupervisionManagement from './pages/SupervisionManagement';
import TopicRecords from './pages/TopicRecords';
import TradeRecords from './pages/TradeRecords';
import Webhooks from './pages/Webhooks';
import Navbar from './components/Navbar';
import ProtectedRoute from './components/ProtectedRoute';

const { Content } = Layout;

function DesktopApp() {
  return (
    <Router>
      <Layout style={{ minHeight: '100vh' }}>
        <Navbar />
        <Layout>
          <Content style={{ padding: '24px', background: '#fff' }}>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />

              <Route
                path="/welcome"
                element={
                  <ProtectedRoute>
                    <Welcome />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/permission"
                element={
                  <ProtectedRoute>
                    <PermissionManagement />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/supervision"
                element={
                  <ProtectedRoute>
                    <SupervisionManagement />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/master-data"
                element={
                  <ProtectedRoute>
                    <MasterData />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/topic-records"
                element={
                  <ProtectedRoute>
                    <TopicRecords />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/trade-records"
                element={
                  <ProtectedRoute>
                    <TradeRecords />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/webhooks"
                element={
                  <ProtectedRoute>
                    <Webhooks />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </Content>
        </Layout>
      </Layout>
    </Router>
  );
}

export default DesktopApp;
